import { Button, Card, Divider, Form, Input, message, Radio, Typography } from "antd";
import type { FormProps } from "antd";
import FileUpload from "components/FileUpload";
import PageTitle from "components/PageTitle";
import { BlogVisibilityTypes } from "dtos/blog.dto";
import { T_Category, T_Category_Type, T_UpdateBlog } from "dtos/category.dto";
import { ApiService } from "api/api.service";
import type { AxiosError } from "axios";
import { T_Api_Error_Res } from "api/api.types";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { TbLoader } from "react-icons/tb";
import DashboardLayout from "layout/DashboardLayout";

const CategoryItem = () => {
  const { slug } = useParams();
  const addCategory = ApiService.category.useAddCategory();
  const updateCategory = ApiService.category.useUpdatecategory();
  const categoryItem = ApiService.category.useGetByIdOrSlug(slug);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [categoryForm] = Form.useForm();
  const categoryData = categoryItem.data;
  useEffect(() => {
    categoryForm.setFieldsValue({
      title: categoryData?.title,
      description: categoryData?.description,
      visbility_type: categoryData?.visbility_type,
      type: categoryData?.type,
    });
  }, [categoryData, categoryForm]);
  const formatTypes = (value: string) => {
    const formattedvalue = value.replace(/_/g, " ");
    return formattedvalue[0].toUpperCase() + formattedvalue.slice(1).toLowerCase();
  };
  const onFinish = async () => {
    try {
      const formData = await categoryForm.validateFields();
      const updateCategoryData: T_UpdateBlog = { ...formData };
      if (categoryData && slug) {
        updateCategory.mutate(
          { id: categoryData._id, body: updateCategoryData },
          {
            onSuccess: () => {
              message.success("Category updated successfully !");
              navigate(`/dashboard/categories?page=${searchParams.get("page")}&limit=${searchParams.get("limit")}`);
            },
            onError: () => {},
          },
        );
      } else {
        addCategory.mutate(formData, {
          onSuccess: () => {
            message.success("Category added successfully");
            navigate("/dashboard/categories");
          },
          onError: () => {},
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <DashboardLayout
      headerRight={
        <Button
          disabled={updateCategory.isPending || addCategory.isPending}
          type="primary"
          onClick={onFinish}
          htmlType="submit"
          icon={(updateCategory.isPending || addCategory.isPending) && <TbLoader className="animate-spin" />}
        >
          {categoryData
            ? updateCategory.isPending
              ? "Updating category..."
              : "Update category"
            : addCategory.isPending
              ? "Adding category..."
              : "Add category"}
        </Button>
      }
    >
      <div className="flex m-6">
        <Card className="m-auto" style={{ width: 600, maxWidth: "100%" }}>
          <PageTitle title="Category" pageTitle={[{ title: "Category" }]} />
          <Form layout="vertical" form={categoryForm}>
            <Form.Item<T_Category>
              name={"title"}
              label="Title"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item<T_Category>
              name={"description"}
              label="Description"
              rules={[{ required: true, message: "please fill this input" }]}
            >
              <Input.TextArea autoSize={{ minRows: 4 }} />
            </Form.Item>
            <Typography.Title level={5}>Visibility</Typography.Title>
            <Form.Item<T_Category> name={"visbility_type"}>
              <Radio.Group>
                {Object.entries(BlogVisibilityTypes).map(([key, val]) => {
                  return (
                    <Radio.Button key={key} value={val}>
                      {formatTypes(key)}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Form.Item>
            <Typography.Title level={5}>Category type</Typography.Title>
            <Form.Item<T_Category> name={"type"}>
              <Radio.Group disabled={categoryData && categoryData?.blogCount > 0}>
                {Object.entries(T_Category_Type).map(([key, val]) => {
                  return (
                    <Radio.Button key={key} value={val}>
                      {formatTypes(key)}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Form.Item>
            {/* <Button
              disabled={updateCategory.isPending || addCategory.isPending}
              type="primary"
              onClick={onFinish}
              htmlType="submit"
              icon={(updateCategory.isPending || addCategory.isPending) && <TbLoader className="animate-spin" />}
            >
              {categoryData
                ? updateCategory.isPending
                  ? "Updating category..."
                  : "Update category"
                : addCategory.isPending
                  ? "Adding category..."
                  : "Add category"}
            </Button> */}
          </Form>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default CategoryItem;
